import { Link } from "react-router-dom";

const relatedTools = {
  "pdf-to-image": [
    { path: "/image-to-pdf", label: "Image to PDF Converter" },
    { path: "/pdf-compress", label: "Compress PDF" },
    { path: "/pdf-split", label: "Split PDF Pages" },
  ],
  "image-to-pdf": [
    { path: "/pdf-to-image", label: "PDF to Image Converter" },
    { path: "/pdf-merge", label: "Merge PDF Files" },
    { path: "/pdf-compress", label: "Compress PDF" },
  ],
  "pdf-merge": [
    { path: "/pdf-split", label: "Split PDF Pages" },
    { path: "/pdf-organize", label: "Organize PDF Pages" },
    { path: "/pdf-compress", label: "Compress PDF" },
  ],
  "pdf-split": [
    { path: "/pdf-merge", label: "Merge PDF Files" },
    { path: "/pdf-delete-pages", label: "Delete PDF Pages" },
    { path: "/pdf-organize", label: "Organize PDF Pages" },
  ],
  "pdf-compress": [
    { path: "/pdf-to-image", label: "PDF to Image Converter" },
    { path: "/pdf-merge", label: "Merge PDF Files" },
    { path: "/pdf-protect", label: "Protect PDF" },
  ],
  "pdf-ocr": [
    { path: "/pdf-to-image", label: "PDF to Image Converter" },
    { path: "/pdf-edit", label: "Edit PDF Text" },
    { path: "/pdf-scanned", label: "Make PDF Look Scanned" },
  ],
  "pdf-edit": [
    { path: "/pdf-sign", label: "Sign PDF" },
    { path: "/pdf-watermark", label: "Add Watermark" },
    { path: "/pdf-ocr", label: "PDF OCR Tool" },
  ],
  "pdf-sign": [
    { path: "/pdf-edit", label: "Edit PDF Text" },
    { path: "/pdf-protect", label: "Protect PDF" },
    { path: "/pdf-watermark", label: "Add Watermark" },
  ],
  "pdf-protect": [
    { path: "/pdf-unlock", label: "Unlock PDF" },
    { path: "/pdf-sign", label: "Sign PDF" },
    { path: "/pdf-watermark", label: "Add Watermark" },
  ],
  "pdf-unlock": [
    { path: "/pdf-protect", label: "Protect PDF" },
    { path: "/pdf-edit", label: "Edit PDF Text" },
    { path: "/pdf-compress", label: "Compress PDF" },
  ],
  "pdf-rotate": [
    { path: "/pdf-organize", label: "Organize PDF Pages" },
    { path: "/pdf-delete-pages", label: "Delete PDF Pages" },
    { path: "/pdf-merge", label: "Merge PDF Files" },
  ],
  "pdf-organize": [
    { path: "/pdf-rotate", label: "Rotate PDF Pages" },
    { path: "/pdf-delete-pages", label: "Delete PDF Pages" },
    { path: "/pdf-split", label: "Split PDF" },
  ],
  "pdf-delete-pages": [
    { path: "/pdf-organize", label: "Organize PDF Pages" },
    { path: "/pdf-split", label: "Split PDF" },
    { path: "/pdf-merge", label: "Merge PDF Files" },
  ],
  "pdf-watermark": [
    { path: "/pdf-sign", label: "Sign PDF" },
    { path: "/pdf-edit", label: "Edit PDF Text" },
    { path: "/pdf-protect", label: "Protect PDF" },
  ],
  "pdf-scanned": [
    { path: "/pdf-ocr", label: "PDF OCR Tool" },
    { path: "/pdf-to-image", label: "PDF to Image Converter" },
    { path: "/pdf-compress", label: "Compress PDF" },
  ],
};

const RelatedTools = ({ currentTool }) => {
  const tools = relatedTools[currentTool] || [];
  
  if (tools.length === 0) return null;

  return (
    <section className="mt-12 border-t border-border pt-8">
      <h2 className="text-xl font-semibold mb-4 font-['Outfit']">Related PDF Tools</h2>
      <div className="flex flex-wrap gap-3">
        {tools.map((tool) => (
          <Link
            key={tool.path}
            to={tool.path}
            className="px-4 py-2 bg-secondary hover:bg-secondary/80 border border-border transition-colors text-sm font-medium"
          >
            {tool.label} →
          </Link>
        ))}
        <Link
          to="/"
          className="px-4 py-2 bg-black text-white hover:bg-black/90 transition-colors text-sm font-medium"
        >
          View All Tools →
        </Link>
      </div>
    </section>
  );
};

export default RelatedTools;
